import { print } from 'graphql'
import type { TypedDocumentNode } from '@graphql-typed-document-node/core'
import { SHOPIFY_API_VERSION } from './config'

const getConfig = () => {
  if (
    !process.env.GATSBY_SHOPIFY_DOMAIN_V2 ||
    !process.env.GATSBY_SHOPIFY_STOREFRONT_ACCESS_TOKEN_V2
  ) {
    throw new Error('Missing Shopify Storefront configuration')
  }

  return {
    graphqlUrl: `https://${process.env.GATSBY_SHOPIFY_DOMAIN_V2}/api/${SHOPIFY_API_VERSION}/graphql.json`,
    accessToken: process.env.GATSBY_SHOPIFY_STOREFRONT_ACCESS_TOKEN_V2,
  }
}

type RequestOptions = {
  // Let the browser finish the request after the page navigates away.
  keepalive?: boolean
}

export const shopifyStorefrontGraphql = async <TData, TVars>(
  document: TypedDocumentNode<TData, TVars>,
  variables: TVars,
  { keepalive = false }: RequestOptions = {}
): Promise<TData> => {
  const { graphqlUrl, accessToken } = getConfig()
  const res = await fetch(graphqlUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': accessToken,
    },
    body: JSON.stringify({ query: print(document), variables }),
    keepalive,
  })

  const json = (await res.json()) as {
    data: TData
    errors?: { message: string }[]
  }

  if (json.errors?.length) {
    throw new Error(json.errors.map((e) => e.message).join('; '))
  }

  if (!json.data) {
    throw new Error('Shopify GraphQL response missing data')
  }

  return json.data
}
